export default __webpack_public_path__ + "static/media/auto-exec-vpn.be4d5a24.png";